/** Discovery may hide machine-only rules independently of a list's provenance. */
export function courseListDescription(description: string | null | undefined, hideStructuredRules: boolean): string | null {
  const text = description?.trim();
  if (!text) return null;
  if (!hideStructuredRules) return text;
  const courseTokens = /\b(?:\d{2}|TR|MA):[\w*]+:[\w*]+/g;
  const containsCourseTokens = Boolean(text.match(courseTokens)?.length);
  const withoutModifiers = text.replace(/\\@[a-zA-Z][\w-]*/g, '').trim();
  const withoutTokens = withoutModifiers.replace(courseTokens, '');
  if (containsCourseTokens && /^[{[(]/.test(text) && /[})\]]$/.test(withoutModifiers) && /^[\s{}()[\],\\]*$/.test(withoutTokens)) {
    const openings: string[] = [];
    const pairs: Record<string, string> = { '}': '{', ')': '(', ']': '[' };
    for (const character of withoutTokens) {
      if ('{(['.includes(character)) openings.push(character);
      else if (pairs[character] && openings.pop() !== pairs[character]) return text;
    }
    if (!openings.length) return null;
  }
  return text;
}
